import { PageHeader } from '@platform/design-system';
import type { ReactNode } from 'react';
import { usePageContext } from '../usePageContext.ts';
import { FinanceSections, type FinanceSection } from './FinanceSections.tsx';

export type FinanceFrameProps = {
  section: FinanceSection;
  context: string;
  action?: ReactNode;
  onSection: (section: FinanceSection) => void;
  children: ReactNode;
};

export const FinanceFrame = ({ section, context, action, onSection, children }: FinanceFrameProps) => {
  const { t } = usePageContext();
  return (
    <>
      <PageHeader title={t('nav.finance')} context={context} action={action} />
      <FinanceSections current={section} onSelect={onSection} />
      {children}
    </>
  );
};
